module.exports = __webpack_public_path__ + "static/img/hbg.98df94ab.svg";